import { render, staticRenderFns } from "./CapillaryViz.vue?vue&type=template&id=0a82eba6&scoped=true"
import script from "./CapillaryViz.vue?vue&type=script&lang=js"
export * from "./CapillaryViz.vue?vue&type=script&lang=js"
import style0 from "./CapillaryViz.vue?vue&type=style&index=0&id=0a82eba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a82eba6",
  null
  
)

export default component.exports